
import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

 function About(props) {
    
    return (
<>

<div className="aboutSection">
    <h3 className='sectionHeading'>About Us</h3>
    <span className='headingAfterLine'></span>
    
    <Row className='mt-5'>
        <Col md={7}>
        <div className="aboutContentWrap">
        <div className='aboutContent'>Parishrama Divyang Sports Academy is Non-profit organization (NGO) more than just a sports organization—it’s a movement towards inclusion, empowerment, and excellence. Founded with the mission to promote sports among persons with disabilities, we aim to break barriers and create opportunities for everyone to thrive.</div>
            <h5>Our Vision:</h5>
            <p className='visionContent'>To be a beacon of hope and excellence for differently abled athletes, transforming lives through sports and fostering an inclusive society.</p>
            
        </div>
        </Col>
        <Col md={5}>
        <div className='missionWrap'>
        <h5>Our Mission:</h5>
            <ul>
                <li>To provide state-of-the-art facilities and resources for PWD athletes.</li>
                <li>To conduct regular training, workshops, and competitions that nurture talent.</li>
                <li>To raise awareness about the importance of inclusive sports in building a cohesive community.</li>
                <li>Organizing sports events at the state and national levels.</li>
            </ul>
            <p>With a team of dedicated professionals and passionate volunteers, we’ve been at the forefront of organizing impactful events that bring together athletes, families, and communities. Together, we’re changing perspectives and unlocking potential</p>
            </div>
        {/* <div className="aboutImagWrap">
            <img src={aboutImg} alt="about-sports" className='aboutSportsImg' />
        </div> */}
        </Col>
    </Row>
</div>

</>

    )

}

export default About
